import { __commonJSMin as e } from "../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/dompurify@3.4.0/node_modules/dompurify/dist/purify.cjs.js
var t = /* @__PURE__ */ e(((e, t) => {
	var { entries: n, setPrototypeOf: r, isFrozen: i, getPrototypeOf: a, getOwnPropertyDescriptor: o } = Object, { freeze: s, seal: c, create: l } = Object, { apply: u, construct: d } = typeof Reflect < "u" && Reflect;
	s ||= function(e) {
		return e;
	}, c ||= function(e) {
		return e;
	}, u ||= function(e, t) {
		var n = [...arguments].slice(2);
		return e.apply(t, n);
	}, d ||= function(e) {
		return new e(...[...arguments].slice(1));
	};
	var f = v(Array.prototype.forEach), ee = v(Array.prototype.lastIndexOf), te = v(Array.prototype.pop), p = v(Array.prototype.push), ne = v(Array.prototype.splice), re = v(String.prototype.toLowerCase), ie = v(String.prototype.toString), ae = v(String.prototype.match), m = v(String.prototype.replace), oe = v(String.prototype.indexOf), se = v(String.prototype.trim), h = v(Object.prototype.hasOwnProperty), g = v(RegExp.prototype.test), _ = ce(TypeError);
	function v(e) {
		return function(t) {
			t instanceof RegExp && (t.lastIndex = 0);
			var n = [...arguments].slice(1);
			return u(e, t, n);
		};
	}
	function ce(e) {
		return function() {
			return d(e, [...arguments]);
		};
	}
	function y(e, t) {
		let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : re;
		r && r(e, null);
		let a = t.length;
		for (; a--;) {
			let r = t[a];
			if (typeof r == "string") {
				let e = n(r);
				e !== r && (i(t) || (t[a] = e), r = e);
			}
			e[r] = !0;
		}
		return e;
	}
	function le(e) {
		for (let t = 0; t < e.length; t++) h(e, t) || (e[t] = null);
		return e;
	}
	function b(e) {
		let t = l(null);
		for (let [r, i] of n(e)) h(e, r) && (Array.isArray(i) ? t[r] = le(i) : i && typeof i == "object" && i.constructor === Object ? t[r] = b(i) : t[r] = i);
		return t;
	}
	function x(e, t) {
		for (; e !== null;) {
			let n = o(e, t);
			if (n) {
				if (n.get) return v(n.get);
				if (typeof n.value == "function") return v(n.value);
			}
			e = a(e);
		}
		function n() {
			return null;
		}
		return n;
	}
	var ue = s(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), de = s(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), fe = s([
		"feBlend",
		"feColorMatrix",
		"feComponentTransfer",
		"feComposite",
		"feConvolveMatrix",
		"feDiffuseLighting",
		"feDisplacementMap",
		"feDistantLight",
		"feDropShadow",
		"feFlood",
		"feFuncA",
		"feFuncB",
		"feFuncG",
		"feFuncR",
		"feGaussianBlur",
		"feImage",
		"feMerge",
		"feMergeNode",
		"feMorphology",
		"feOffset",
		"fePointLight",
		"feSpecularLighting",
		"feSpotLight",
		"feTile",
		"feTurbulence"
	]), pe = s([
		"animate",
		"color-profile",
		"cursor",
		"discard",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"foreignobject",
		"hatch",
		"hatchpath",
		"mesh",
		"meshgradient",
		"meshpatch",
		"meshrow",
		"missing-glyph",
		"script",
		"set",
		"solidcolor",
		"unknown",
		"use"
	]), me = s(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), he = s([
		"maction",
		"maligngroup",
		"malignmark",
		"mlongdiv",
		"mscarries",
		"mscarry",
		"msgroup",
		"mstack",
		"msline",
		"msrow",
		"semantics",
		"annotation",
		"annotation-xml",
		"mprescripts",
		"none"
	]), ge = s(["#text"]), _e = s(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns.slot".split(".")), ve = s(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-rendering.textlength.type.u1.u2.unicode.values.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), ye = s(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), S = s([
		"xlink:href",
		"xml:id",
		"xlink:title",
		"xml:space",
		"xmlns:xlink"
	]), be = c(/\{\{[\w\W]*|[\w\W]*\}\}/gm), C = c(/<%[\w\W]*|[\w\W]*%>/gm), w = c(/\$\{[\w\W]*/gm), xe = c(/^data-[\-\w.\u00B7-\uFFFF]+$/), Se = c(/^aria-[\-\w]+$/), Ce = c(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), we = c(/^(?:\w+script|data):/i), Te = c(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), Ee = c(/^html$/i), T = c(/^[a-z][.\w]*(-[.\w]+)+$/i), De = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		ARIA_ATTR: Se,
		ATTR_WHITESPACE: Te,
		CUSTOM_ELEMENT: T,
		DATA_ATTR: xe,
		DOCTYPE_NAME: Ee,
		ERB_EXPR: C,
		IS_ALLOWED_URI: Ce,
		IS_SCRIPT_OR_DATA: we,
		MUSTACHE_EXPR: be,
		TMPLIT_EXPR: w
	}), E = {
		element: 1,
		text: 3,
		progressingInstruction: 7,
		comment: 8,
		document: 9
	}, Oe = function() {
		return typeof window > "u" ? null : window;
	}, ke = function(e, t) {
		if (typeof e != "object" || typeof e.createPolicy != "function") return null;
		let n = null, r = "data-tt-policy-suffix";
		t && t.hasAttribute(r) && (n = t.getAttribute(r));
		let i = "dompurify" + (n ? "#" + n : "");
		try {
			return e.createPolicy(i, {
				createHTML(e) {
					return e;
				},
				createScriptURL(e) {
					return e;
				}
			});
		} catch {
			return console.warn("TrustedTypes policy " + i + " could not be created."), null;
		}
	}, Ae = function() {
		return {
			afterSanitizeAttributes: [],
			afterSanitizeElements: [],
			afterSanitizeShadowDOM: [],
			beforeSanitizeAttributes: [],
			beforeSanitizeElements: [],
			beforeSanitizeShadowDOM: [],
			uponSanitizeAttribute: [],
			uponSanitizeElement: [],
			uponSanitizeShadowNode: []
		};
	};
	function je() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Oe(), t = (e) => je(e);
		if (t.version = "3.4.0", t.removed = [], !e || !e.document || e.document.nodeType !== E.document || !e.Element) return t.isSupported = !1, t;
		let { document: r } = e, i = r, a = i.currentScript, { DocumentFragment: o, HTMLTemplateElement: c, Node: u, Element: d, NodeFilter: v, NamedNodeMap: ce = e.NamedNodeMap || e.MozNamedAttrMap, HTMLFormElement: le, DOMParser: be, trustedTypes: C } = e, w = d.prototype, xe = x(w, "cloneNode"), Se = x(w, "remove"), we = x(w, "nextSibling"), Te = x(w, "childNodes"), T = x(w, "parentNode");
		if (typeof c == "function") {
			let e = r.createElement("template");
			e.content && e.content.ownerDocument && (r = e.content.ownerDocument);
		}
		let D, O = "", { implementation: Me, createNodeIterator: Ne, createDocumentFragment: Pe, getElementsByTagName: Fe } = r, { importNode: Ie } = i, k = Ae();
		t.isSupported = typeof n == "function" && typeof T == "function" && Me && Me.createHTMLDocument !== void 0;
		let { MUSTACHE_EXPR: Le, ERB_EXPR: Re, TMPLIT_EXPR: ze, DATA_ATTR: Be, ARIA_ATTR: Ve, IS_SCRIPT_OR_DATA: He, ATTR_WHITESPACE: Ue, CUSTOM_ELEMENT: We } = De, { IS_ALLOWED_URI: Ge } = De, A = null, Ke = y({}, [
			...ue,
			...de,
			...fe,
			...me,
			...ge
		]), j = null, qe = y({}, [
			..._e,
			...ve,
			...ye,
			...S
		]), M = Object.seal(l(null, {
			tagNameCheck: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: null
			},
			attributeNameCheck: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: null
			},
			allowCustomizedBuiltInElements: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: !1
			}
		})), N = null, Je = null, P = Object.seal(l(null, {
			tagCheck: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: null
			},
			attributeCheck: {
				writable: !0,
				configurable: !1,
				enumerable: !0,
				value: null
			}
		})), Ye = !0, Xe = !0, Ze = !1, Qe = !0, F = !1, I = !0, L = !1, $e = !1, et = !1, R = !1, z = !1, B = !1, tt = !0, nt = !1, rt = !0, V = !1, H = {}, U = null, it = y({}, [
			"annotation-xml",
			"audio",
			"colgroup",
			"desc",
			"foreignobject",
			"head",
			"iframe",
			"math",
			"mi",
			"mn",
			"mo",
			"ms",
			"mtext",
			"noembed",
			"noframes",
			"noscript",
			"plaintext",
			"script",
			"style",
			"svg",
			"template",
			"thead",
			"title",
			"video",
			"xmp"
		]), at = null, ot = y({}, [
			"audio",
			"video",
			"img",
			"source",
			"image",
			"track"
		]), st = null, ct = y({}, [
			"alt",
			"class",
			"for",
			"id",
			"label",
			"name",
			"pattern",
			"placeholder",
			"role",
			"summary",
			"title",
			"value",
			"style",
			"xmlns"
		]), W = "http://www.w3.org/1998/Math/MathML", G = "http://www.w3.org/2000/svg", K = "http://www.w3.org/1999/xhtml", q = K, lt = !1, ut = null, dt = y({}, [
			W,
			G,
			K
		], ie), ft = y({}, [
			"mi",
			"mo",
			"mn",
			"ms",
			"mtext"
		]), pt = y({}, ["annotation-xml"]), mt = y({}, [
			"title",
			"style",
			"font",
			"a",
			"script"
		]), J = null, ht = ["application/xhtml+xml", "text/html"], Y = null, X = null, gt = r.createElement("form"), _t = function(e) {
			return e instanceof RegExp || e instanceof Function;
		}, vt = function() {
			let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
			if (!(X && X === e)) {
				if ((!e || typeof e != "object") && (e = {}), e = b(e), J = ht.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, Y = J === "application/xhtml+xml" ? ie : re, A = h(e, "ALLOWED_TAGS") ? y({}, e.ALLOWED_TAGS, Y) : Ke, j = h(e, "ALLOWED_ATTR") ? y({}, e.ALLOWED_ATTR, Y) : qe, ut = h(e, "ALLOWED_NAMESPACES") ? y({}, e.ALLOWED_NAMESPACES, ie) : dt, st = h(e, "ADD_URI_SAFE_ATTR") ? y(b(ct), e.ADD_URI_SAFE_ATTR, Y) : ct, at = h(e, "ADD_DATA_URI_TAGS") ? y(b(ot), e.ADD_DATA_URI_TAGS, Y) : ot, U = h(e, "FORBID_CONTENTS") ? y({}, e.FORBID_CONTENTS, Y) : it, N = h(e, "FORBID_TAGS") ? y({}, e.FORBID_TAGS, Y) : b({}), Je = h(e, "FORBID_ATTR") ? y({}, e.FORBID_ATTR, Y) : b({}), H = h(e, "USE_PROFILES") ? e.USE_PROFILES : !1, Ye = e.ALLOW_ARIA_ATTR !== !1, Xe = e.ALLOW_DATA_ATTR !== !1, Ze = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Qe = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, F = e.SAFE_FOR_TEMPLATES || !1, I = e.SAFE_FOR_XML !== !1, L = e.WHOLE_DOCUMENT || !1, R = e.RETURN_DOM || !1, z = e.RETURN_DOM_FRAGMENT || !1, B = e.RETURN_TRUSTED_TYPE || !1, et = e.FORCE_BODY || !1, tt = e.SANITIZE_DOM !== !1, nt = e.SANITIZE_NAMED_PROPS || !1, rt = e.KEEP_CONTENT !== !1, V = e.IN_PLACE || !1, Ge = e.ALLOWED_URI_REGEXP || Ce, q = e.NAMESPACE || K, ft = e.MATHML_TEXT_INTEGRATION_POINTS || ft, pt = e.HTML_INTEGRATION_POINTS || pt, M = e.CUSTOM_ELEMENT_HANDLING || l(null), e.CUSTOM_ELEMENT_HANDLING && _t(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (M.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && _t(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (M.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (M.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), F && (Xe = !1), z && (R = !0), H && (A = y({}, ge), j = l(null), H.html === !0 && (y(A, ue), y(j, _e)), H.svg === !0 && (y(A, de), y(j, ve), y(j, S)), H.svgFilters === !0 && (y(A, fe), y(j, ve), y(j, S)), H.mathMl === !0 && (y(A, me), y(j, ye), y(j, S))), P.tagCheck = null, P.attributeCheck = null, e.ADD_TAGS && (typeof e.ADD_TAGS == "function" ? P.tagCheck = e.ADD_TAGS : (A === Ke && (A = b(A)), y(A, e.ADD_TAGS, Y))), e.ADD_ATTR && (typeof e.ADD_ATTR == "function" ? P.attributeCheck = e.ADD_ATTR : (j === qe && (j = b(j)), y(j, e.ADD_ATTR, Y))), e.ADD_URI_SAFE_ATTR && y(st, e.ADD_URI_SAFE_ATTR, Y), e.FORBID_CONTENTS && (U === it && (U = b(U)), y(U, e.FORBID_CONTENTS, Y)), e.ADD_FORBID_CONTENTS && (U === it && (U = b(U)), y(U, e.ADD_FORBID_CONTENTS, Y)), rt && (A["#text"] = !0), L && y(A, [
					"html",
					"head",
					"body"
				]), A.table && (y(A, ["tbody"]), delete N.tbody), e.TRUSTED_TYPES_POLICY) {
					if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw _("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
					if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw _("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
					D = e.TRUSTED_TYPES_POLICY, O = D.createHTML("");
				} else D === void 0 && (D = ke(C, a)), D !== null && typeof O == "string" && (O = D.createHTML(""));
				s && s(e), X = e;
			}
		}, yt = y({}, [
			...de,
			...fe,
			...pe
		]), bt = y({}, [...me, ...he]), xt = function(e) {
			let t = T(e);
			(!t || !t.tagName) && (t = {
				namespaceURI: q,
				tagName: "template"
			});
			let n = re(e.tagName), r = re(t.tagName);
			return ut[e.namespaceURI] ? e.namespaceURI === G ? t.namespaceURI === K ? n === "svg" : t.namespaceURI === W ? n === "svg" && (r === "annotation-xml" || ft[r]) : !!yt[n] : e.namespaceURI === W ? t.namespaceURI === K ? n === "math" : t.namespaceURI === G ? n === "math" && pt[r] : !!bt[n] : e.namespaceURI === K ? t.namespaceURI === G && !pt[r] || t.namespaceURI === W && !ft[r] ? !1 : !bt[n] && (mt[n] || !yt[n]) : !!(J === "application/xhtml+xml" && ut[e.namespaceURI]) : !1;
		}, Z = function(e) {
			p(t.removed, { element: e });
			try {
				T(e).removeChild(e);
			} catch {
				Se(e);
			}
		}, Q = function(e, n) {
			try {
				p(t.removed, {
					attribute: n.getAttributeNode(e),
					from: n
				});
			} catch {
				p(t.removed, {
					attribute: null,
					from: n
				});
			}
			if (n.removeAttribute(e), e === "is") if (R || z) try {
				Z(n);
			} catch {}
			else try {
				n.setAttribute(e, "");
			} catch {}
		}, St = function(e) {
			let t = null, n = null;
			if (et) e = "<remove></remove>" + e;
			else {
				let t = ae(e, /^[\r\n\t ]+/);
				n = t && t[0];
			}
			J === "application/xhtml+xml" && q === K && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
			let i = D ? D.createHTML(e) : e;
			if (q === K) try {
				t = new be().parseFromString(i, J);
			} catch {}
			if (!t || !t.documentElement) {
				t = Me.createDocument(q, "template", null);
				try {
					t.documentElement.innerHTML = lt ? O : i;
				} catch {}
			}
			let a = t.body || t.documentElement;
			return e && n && a.insertBefore(r.createTextNode(n), a.childNodes[0] || null), q === K ? Fe.call(t, L ? "html" : "body")[0] : L ? t.documentElement : a;
		}, Ct = function(e) {
			return Ne.call(e.ownerDocument || e, e, v.SHOW_ELEMENT | v.SHOW_COMMENT | v.SHOW_TEXT | v.SHOW_PROCESSING_INSTRUCTION | v.SHOW_CDATA_SECTION, null);
		}, wt = function(e) {
			return e instanceof le && (typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || !(e.attributes instanceof ce) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function");
		}, Tt = function(e) {
			return typeof u == "function" && e instanceof u;
		};
		function $(e, n, r) {
			f(e, (e) => {
				e.call(t, n, r, X);
			});
		}
		let Et = function(e) {
			let n = null;
			if ($(k.beforeSanitizeElements, e, null), wt(e)) return Z(e), !0;
			let r = Y(e.nodeName);
			if ($(k.uponSanitizeElement, e, {
				tagName: r,
				allowedTags: A
			}), I && e.hasChildNodes() && !Tt(e.firstElementChild) && g(/<[/\w!]/g, e.innerHTML) && g(/<[/\w!]/g, e.textContent) || I && e.namespaceURI === K && r === "style" && Tt(e.firstElementChild) || e.nodeType === E.progressingInstruction || I && e.nodeType === E.comment && g(/<[/\w]/g, e.data)) return Z(e), !0;
			if (N[r] || !(P.tagCheck instanceof Function && P.tagCheck(r)) && !A[r]) {
				if (!N[r] && Ot(r) && (M.tagNameCheck instanceof RegExp && g(M.tagNameCheck, r) || M.tagNameCheck instanceof Function && M.tagNameCheck(r))) return !1;
				if (rt && !U[r]) {
					let t = T(e) || e.parentNode, n = Te(e) || e.childNodes;
					if (n && t) {
						let r = n.length;
						for (let i = r - 1; i >= 0; --i) {
							let r = xe(n[i], !0);
							r.__removalCount = (e.__removalCount || 0) + 1, t.insertBefore(r, we(e));
						}
					}
				}
				return Z(e), !0;
			}
			return e instanceof d && !xt(e) || (r === "noscript" || r === "noembed" || r === "noframes") && g(/<\/no(script|embed|frames)/i, e.innerHTML) ? (Z(e), !0) : (F && e.nodeType === E.text && (n = e.textContent, f([
				Le,
				Re,
				ze
			], (e) => {
				n = m(n, e, " ");
			}), e.textContent !== n && (p(t.removed, { element: e.cloneNode() }), e.textContent = n)), $(k.afterSanitizeElements, e, null), !1);
		}, Dt = function(e, t, n) {
			if (Je[t] || tt && (t === "id" || t === "name") && (n in r || n in gt)) return !1;
			if (!(Xe && !Je[t] && g(Be, t)) && !(Ye && g(Ve, t)) && !(P.attributeCheck instanceof Function && P.attributeCheck(t, e))) {
				if (!j[t] || Je[t]) {
					if (!(Ot(e) && (M.tagNameCheck instanceof RegExp && g(M.tagNameCheck, e) || M.tagNameCheck instanceof Function && M.tagNameCheck(e)) && (M.attributeNameCheck instanceof RegExp && g(M.attributeNameCheck, t) || M.attributeNameCheck instanceof Function && M.attributeNameCheck(t, e)) || t === "is" && M.allowCustomizedBuiltInElements && (M.tagNameCheck instanceof RegExp && g(M.tagNameCheck, n) || M.tagNameCheck instanceof Function && M.tagNameCheck(n)))) return !1;
				} else if (!st[t] && !g(Ge, m(n, Ue, "")) && !((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && oe(n, "data:") === 0 && at[e]) && !(Ze && !g(He, m(n, Ue, ""))) && n) return !1;
			}
			return !0;
		}, Ot = function(e) {
			return e !== "annotation-xml" && ae(e, We);
		}, kt = function(e) {
			$(k.beforeSanitizeAttributes, e, null);
			let { attributes: n } = e;
			if (!n || wt(e)) return;
			let r = {
				attrName: "",
				attrValue: "",
				keepAttr: !0,
				allowedAttributes: j,
				forceKeepAttr: void 0
			}, i = n.length;
			for (; i--;) {
				let { name: a, namespaceURI: o, value: s } = n[i], c = Y(a), l = s, u = a === "value" ? l : se(l);
				if (r.attrName = c, r.attrValue = u, r.keepAttr = !0, r.forceKeepAttr = void 0, $(k.uponSanitizeAttribute, e, r), u = r.attrValue, nt && (c === "id" || c === "name") && (Q(a, e), u = "user-content-" + u), I && g(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, u)) {
					Q(a, e);
					continue;
				}
				if (c === "attributename" && ae(u, "href")) {
					Q(a, e);
					continue;
				}
				if (r.forceKeepAttr) continue;
				if (!r.keepAttr) {
					Q(a, e);
					continue;
				}
				if (!Qe && g(/\/>/i, u)) {
					Q(a, e);
					continue;
				}
				F && f([
					Le,
					Re,
					ze
				], (e) => {
					u = m(u, e, " ");
				});
				let d = Y(e.nodeName);
				if (!Dt(d, c, u)) {
					Q(a, e);
					continue;
				}
				if (D && typeof C == "object" && typeof C.getAttributeType == "function" && !o) switch (C.getAttributeType(d, c)) {
					case "TrustedHTML":
						u = D.createHTML(u);
						break;
					case "TrustedScriptURL":
						u = D.createScriptURL(u);
						break;
				}
				if (u !== l) try {
					o ? e.setAttributeNS(o, a, u) : e.setAttribute(a, u), wt(e) ? Z(e) : te(t.removed);
				} catch {
					Q(a, e);
				}
			}
			$(k.afterSanitizeAttributes, e, null);
		}, At = function(e) {
			let t = null, n = Ct(e);
			for ($(k.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) $(k.uponSanitizeShadowNode, t, null), Et(t), kt(t), t.content instanceof o && At(t.content);
			$(k.afterSanitizeShadowDOM, e, null);
		};
		return t.sanitize = function(e) {
			let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = null, a = null, s = null, c = null;
			if (lt = !e, lt && (e = "<!-->"), typeof e != "string" && !Tt(e)) if (typeof e.toString == "function") {
				if (e = e.toString(), typeof e != "string") throw _("dirty is not a string, aborting");
			} else throw _("toString is not a function");
			if (!t.isSupported) return e;
			if ($e || vt(n), t.removed = [], typeof e == "string" && (V = !1), V) {
				if (e.nodeName) {
					let t = Y(e.nodeName);
					if (!A[t] || N[t]) throw _("root node is forbidden and cannot be sanitized in-place");
				}
			} else if (e instanceof u) r = St("<!---->"), a = r.ownerDocument.importNode(e, !0), a.nodeType === E.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? r = a : r.appendChild(a);
			else {
				if (!R && !F && !L && e.indexOf("<") === -1) return D && B ? D.createHTML(e) : e;
				if (r = St(e), !r) return R ? null : B ? O : "";
			}
			r && et && Z(r.firstChild);
			let l = Ct(V ? e : r);
			for (; s = l.nextNode();) Et(s), kt(s), s.content instanceof o && At(s.content);
			if (V) return e;
			if (R) {
				if (F) {
					r.normalize();
					let e = r.innerHTML;
					f([
						Le,
						Re,
						ze
					], (t) => {
						e = m(e, t, " ");
					}), r.innerHTML = e;
				}
				if (z) for (c = Pe.call(r.ownerDocument); r.firstChild;) c.appendChild(r.firstChild);
				else c = r;
				return (j.shadowroot || j.shadowrootmode) && (c = Ie.call(i, c, !0)), c;
			}
			let d = L ? r.outerHTML : r.innerHTML;
			return L && A["!doctype"] && r.ownerDocument && r.ownerDocument.doctype && r.ownerDocument.doctype.name && g(Ee, r.ownerDocument.doctype.name) && (d = "<!DOCTYPE " + r.ownerDocument.doctype.name + ">\n" + d), F && f([
				Le,
				Re,
				ze
			], (e) => {
				d = m(d, e, " ");
			}), D && B ? D.createHTML(d) : d;
		}, t.setConfig = function() {
			vt(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}), $e = !0;
		}, t.clearConfig = function() {
			X = null, $e = !1;
		}, t.isValidAttribute = function(e, t, n) {
			return X || vt({}), Dt(Y(e), Y(t), n);
		}, t.addHook = function(e, t) {
			typeof t == "function" && p(k[e], t);
		}, t.removeHook = function(e, t) {
			if (t !== void 0) {
				let n = ee(k[e], t);
				return n === -1 ? void 0 : ne(k[e], n, 1)[0];
			}
			return te(k[e]);
		}, t.removeHooks = function(e) {
			k[e] = [];
		}, t.removeAllHooks = function() {
			k = Ae();
		}, t;
	}
	t.exports = je();
}));
//#endregion
export default t();
export { t as require_purify_cjs };
